import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// Create a context with default values
const UserContext = createContext({
  firstName: '',
  lastName: '',
  userId: '',
  roles: '',
  slot_number: '',
  patientId: '',
  visit_id: '', 
  department_name: '',
  department_type: '',
  office_id: '',
  permissions: [], // New permissions field
  isAuthenticated: false, // Add authentication status
  setUserInfo: () => {},
  setPatientInfo: () => {}, // Function to update the patientId
  logout: () => {},
  hasPermission: () => {} // Function to check permissions
});

// Custom hook to use the UserContext
export const useUser = () => useContext(UserContext);

// UserProvider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
      
  
    // Check both token and user data
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    const isAuth = !!(token && savedUser);
    
    if (savedUser && token) {
      return { 
        ...JSON.parse(savedUser), 
        isAuthenticated: true 
      };
    }

    return { 
      firstName: '', 
      lastName: '', 
      userId: '', 
      roles: '', 
      slot_number: '', 
      patientId: '', 
      visit_id: '', 
      department_name: '', 
      department_type: '', 
      office_id: '',
      permissions: [],
      isAuthenticated: false
    };
  });
     // Check authentication status on mount and when token changes
  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    const isAuth = !!(token && savedUser);
    
    if (isAuth !== user.isAuthenticated) {
      setUser(prev => ({ ...prev, isAuthenticated: isAuth }));
    }
  }, []);

  const setUserInfo = (firstName, lastName, userId, roles, slot_number, department_name, department_type, office_id, permissions) => {
    const newUser = { 
      firstName, 
      lastName, 
      userId, 
      roles, 
      slot_number, 
      department_name, 
      department_type, 
      office_id, 
      permissions,
      isAuthenticated: true,
      patientId: '', // Reset patient info on new login
      visit_id: ''
    };
    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser));
  };

   const setPatientInfo = ({ patientId, visit_id }) => {
    const updatedUser = { ...user, patientId, visit_id };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  const logout = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        await axios.post(`${BASE_URL}/auth/logout`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    } catch (error) {
      console.warn('Server logout failed or already invalidated:', error.message);
    }

    // Clear user state
    const clearedUser = { 
      firstName: '', 
      lastName: '', 
      userId: '', 
      roles: '', 
      slot_number: '', 
      patientId: '', 
      visit_id: '',
      department_name: '', 
      department_type: '', 
      office_id: '', 
      permissions: [],
      isAuthenticated: false
    };
    
    setUser(clearedUser);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  // Function to check if the user has a specific permission
  const hasPermission = (permission) => {
    return user.permissions && user.permissions.includes(permission);
  };

  return (
    <UserContext.Provider value={{ ...user, setUserInfo, setPatientInfo, logout, hasPermission }}>
      {children}
    </UserContext.Provider>
  );
};
